module.exports = __webpack_public_path__ + "static/media/Frank Mauck Headshot.398b1963.png";